export default __webpack_public_path__ + "assets/community-one-three-small.aa584b40b592341d313689d97c96bdcd.png";